import React from 'react'
import "./Our_presence.css"
import Common_heading from '../../common_component/common_heading/Common_heading'

function Our_presence() {
    return (
        <>
            <section className='Our_presence'>
                <div className="container">
                    <Common_heading title="OUR PRESENCE" subTitle="Based In Dubai, Operating Across Africa Rwanda, Uganda & DR Congo." />
                    <div className="desc_text_holder">

                        <p>At Ayansh International Trading, we specialize in sourcing and
                            distributing top-notch FMCG products across various categories
                            including food and beverages, Wines & Spirits and more. With a
                            keen focus on quality assurance, we partner with reputable
                            manufacturers and brands globally to ensure that our customers
                            receive nothing but the best.</p>
                        <p>Driven by a passion for
                            customer satisfaction, we strive
                            to exceed expectations by offering
                            an unparalleled level of service,
                            reliability, and flexibility. Our
                            experienced team is dedicated to
                            understanding the unique
                            requirements of each client and
                            delivering tailored solutions that
                            meet their specific needs efficiently
                            and effectively.</p>
                        <p>As a company based in the dynamic
                            business hub of Dubai, UAE, we leverage our strategic location and
                            extensive network to facilitate seamless trade operations in Africa.</p>
                    </div>
                    <div className='content_holder'>

                        <div className='d-flex align-items-center '>
                            <div className='map_img_holder'>

                                <img className="map_img"
                                    src={
                                        process.env.PUBLIC_URL +
                                        "/assets/images/home/our_presence/map.png"
                                    }
                                    alt="map logo"
                                />
                            </div>
                        </div>

                        <div>
                            <div className='location_list_holder'>
                                <div className='list_card_holder'>
                                    <div className='location_img_holder'>
                                        <div className="img_holder">
                                            <img className="location_img"
                                                src={
                                                    process.env.PUBLIC_URL +
                                                    "/assets/images/home/our_presence/location.png"
                                                }
                                                alt="location logo"
                                            />
                                        </div>
                                    </div>
                                    {/* <div className="text_holder">
                                    <h4><sub>UG</sub>🇺🇬 Uganda</h4>
                                    <p>dfgdgs</p>
                                </div> */}

                                    <div className="text_holder">
                                        <h4>🇺🇬 Uganda</h4>
                                        <p>Key distribution hub with a strong retail and wholesale presence.</p>
                                    </div>
                                </div>

                                <div className='list_card_holder'>
                                    <div className='location_img_holder'>
                                        <div className="img_holder">
                                            <img className="location_img"
                                                src={
                                                    process.env.PUBLIC_URL +
                                                    "/assets/images/home/our_presence/location.png"
                                                }
                                                alt="location logo"
                                            />
                                        </div>
                                    </div>
                                    <div className="text_holder">
                                        <h4>🇷🇼 Rwanda</h4>
                                        <p>Strategic operations focused on food and beverage trade.</p>
                                    </div>
                                </div>

                                <div className='list_card_holder'>
                                    <div className='location_img_holder'>
                                        <div className="img_holder">
                                            <img className="location_img"
                                                src={
                                                    process.env.PUBLIC_URL +
                                                    "/assets/images/home/our_presence/location.png"
                                                }
                                                alt="location logo"
                                            />
                                        </div>
                                    </div>
                                    <div className="text_holder">
                                        <h4>🇨🇩 DR Congo</h4>
                                        <p>Expanding logistics and supply chain activities across major cities.</p>
                                    </div>
                                </div>

                                <div className='list_card_holder'>
                                    <div className='location_img_holder'>
                                        <div className="img_holder">
                                            <img className="location_img"
                                                src={
                                                    process.env.PUBLIC_URL +
                                                    "/assets/images/home/our_presence/location.png"
                                                }
                                                alt="location logo"
                                            />
                                        </div>
                                    </div>
                                    <div className="text_holder">
                                        <h4>🇸🇸 South Sudan</h4>
                                        <p>Emerging market for essential goods and B2B trading.</p>
                                    </div>
                                </div>

                                <div className='list_card_holder'>
                                    <div className='location_img_holder'>
                                        <div className="img_holder">
                                            <img className="location_img"
                                                src={
                                                    process.env.PUBLIC_URL +
                                                    "/assets/images/home/our_presence/location.png"
                                                }
                                                alt="location logo"
                                            />
                                        </div>
                                    </div>
                                    <div className="text_holder">
                                        <h4>🇧🇮 Burundi</h4>
                                        <p>Partner-based distribution serving growing consumer demand.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Our_presence